import moment from 'moment-timezone'
import _ from 'lodash'

/**
 * Attempt to guess the timezone based on the "offset" (in minutes).
 * 
 * This function iterates over all the timezones available and looks for the offset
 * which matches
 * 
 * @param  {int} offset
 * 
 * @returns {string} Timezone
 */
export const guessTimezoneFromOffset = (offset) => {
    const now = moment();
    const found = _.find(moment.tz.names(), name => {
        const tzOffset = -moment.tz.zone(name).utcOffset(now);
        return tzOffset === offset;
    })

    return found || "UTC";
}
